/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SpecialityVitals from './speciality-vitals';
import SpecialityVitalsDetail from './speciality-vitals-detail';
import SpecialityVitalsUpdate from './speciality-vitals-update';
import SpecialityVitalsDeleteDialog from './speciality-vitals-delete-dialog';

const SpecialityVitalsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SpecialityVitals />} />
    <Route path="new" element={<SpecialityVitalsUpdate />} />
    <Route path=":id">
      <Route index element={<SpecialityVitalsDetail />} />
      <Route path="edit" element={<SpecialityVitalsUpdate />} />
      <Route path="delete" element={<SpecialityVitalsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SpecialityVitalsRoutes;
